<template>
  <b-modal 
    :hide-footer="true" 
    :centered="true" 
    id="modal-niveles" 
    size="lg"
    scrollable
  >
    <template #modal-header="{ close }">
      <img class="close" src="@/assets/img/close_red.png" @click="close()">
      <h6 class="sub-title">{{$t('planesYPrecios.paso-3.modal-nivel.titulo')}}<span>{{$t('planesYPrecios.paso-3.modal-nivel.subTitulo')}}</span></h6>
      <div class="select-level">
        <button :class="[item.id === levelId_selected ? 'active' : null ,'gd-'+item.id]" v-for="item in levels" :key="item.id" :id="'level_'+item.id" @click="clickTab(item.id)">
          <h1>{{item.abbreviation}}<span>{{item.name}}</span></h1>
        </button>
      </div>
    </template>
    <b-tabs class="tabs-detail-level">
      <b-tab v-model="tabIndex" v-for="item in levels" :key="item.id" :id="'levelTab_'+item.id" :active="item.id === levelId_selected">
	  
        <ul v-if="item.features != null">
          <li v-for="feat in item.features" :key="feat.id" :id="'levelFeature_'+feat.id">
            <h6>{{feat.title}}</h6>
            <div class="box">
              <div class="content" v-for="detail in feat.featureDetails" :key="detail.id" :id="'levelFeatureDetail_'+detail.id">
                <h6>{{detail.title}}</h6>
                <p>{{detail.description}}</p>
              </div>
            </div>
          </li>
        </ul>
		<div v-else class="box">
			<div class="content"> 
				<p>{{$t('planesYPrecios.paso-3.modal-nivel.noInfo')}}</p>
			</div>
        </div>
      </b-tab>
       
    </b-tabs>
  </b-modal>
</template>

<script>
import { baseInstanceAxios } from '@/assets/js/axiosBase.js';

export default {
	data() {
		return {
			API_URL: process.env.VUE_APP_API_URL,
			//levels: [],
			levelId_selected:this.levelAchieved, 
			tabIndex: 0
		}
  },
  props: {
		levels: {
			type: Array
    },
    levelAchieved: {
			type: Number
		}
  },
  watch: { 
    levelAchieved: function(newVal, oldVal) { // watch it
   
      this.levelId_selected = this.levelAchieved;
    }
  },

  methods:{
		
		clickTab: function(levelId) {
      //this.levelAchieved = levelId;
      this.levelId_selected = levelId;
    
    },
    closeModal: function() {
      this.levelId_selected = this.levelAchieved;
      this.$bvModal.hide('modal-niveles');
    }
		 
  }
}
</script>